import React from "react";
import { Button } from "@mui/material";
import { useTranslation } from "hhn-commons";

type ButtonSendReferralType = {
  isUserReferralSelected: boolean;
  onClick: () => void;
};

const ButtonSendReferral = ({
  isUserReferralSelected,
  onClick,
}: ButtonSendReferralType) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "message" });

  return (
    <Button
      disableRipple
      disableTouchRipple
      variant={isUserReferralSelected ? "contained" : "outlined"}
      fullWidth
      disableElevation={isUserReferralSelected}
      data-testid="add-referral-member-btn"
      onClick={onClick}
      style={{ textTransform: "none" }}
    >
      {tNs("referral.sendReferral")}
    </Button>
  );
};

export default ButtonSendReferral;
